import { Box, CardComponent } from '@bpba/ui-components';
import { BPFormProvider, Select } from '@bpba/form-components';
import { UseFormReturn } from 'react-hook-form';
import { FiltersForm, IdLabel } from './styled';

type Props = {
  methods: UseFormReturn<FiltersForm>;
  informeOptions: IdLabel[];
  yearOptions: IdLabel[];
  monthOptions: IdLabel[];
};

export const FiltersCard = ({ methods, informeOptions, yearOptions, monthOptions }: Props) => (
  <CardComponent
    width={['100%', '100%', '100%', '100%', '28%']}
    alignSelf={['auto', null, 'auto', 'auto', 'flex-start']}
    borderRadius={['md', null, 'md', 'md', 'lg']}
  >
    <BPFormProvider methods={methods}>
      <Box display="flex" flexDirection={['column', null, 'row', 'row', 'column']} style={{ gap: '16px' }}>
        <Box width={['100%', null, '33%', '33%', '100%']} display="block">
          <Select name="informe" label="Informe" options={informeOptions} placeholder="Todos los informes" clearable width="100%" />
        </Box>
        <Box width={['100%', null, '33%', '33%', '100%']} display="block">
          <Select name="year" label="Año" options={yearOptions} placeholder="Todos los años" clearable width="100%" />
        </Box>
        <Box width={['100%', null, '33%', '33%', '100%']} display="block">
          <Select name="month" label="Mes" options={monthOptions} placeholder="Todos los meses" clearable width="100%" />
        </Box>
      </Box>
    </BPFormProvider>
  </CardComponent>
);
